export const numWithSpaces = (value) => {
  return value.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
}


export const formatNum = (num) => {
  const withSpaces = numWithSpaces(num.toFixed(2))
  return withSpaces.replace(/\.00/, '')
}
